var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlignJustify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H2V4H14V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2V3H14V2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H14V10H2V11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H14V8H2V9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H14V6H2V7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H14V12H2V13Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignJustify);
export default __webpack_public_path__ + "static/media/align-justify.a327b06c65459ec2eabfa84a8df08ea4.svg";
export { ForwardRef as ReactComponent };